// src/components/financeiro/ModalDetalhesLancamento.jsx
import { useState } from "react";
import { formatarMoeda } from "../../utils/formatarMoeda";
import { formatarNomeLower } from "../../utils/formatadores";

export default function ModalDetalhesLancamento({
  lancamento,
  parcelas,
  onClose,
  onSalvarEdicao
}) {
  const [modoEdicao, setModoEdicao] = useState(false);
  const [salvando, setSalvando] = useState(false);

  const parcelasPagas = parcelas.filter((p) => p.status === "pago");
  const valorJaPago = parcelasPagas.reduce((acc, p) => acc + Number(p.valor), 0);

  // Form State para Edição
  const [novoValorTotal, setNovoValorTotal] = useState(lancamento.valorTotal || 0);
  const [novasParcelas, setNovasParcelas] = useState(lancamento.numeroParcelas || 1);
  const [dataInicio, setDataInicio] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [descricao, setDescricao] = useState(lancamento.descricao || "");

  const handleSalvar = async () => {
    if (Number(novoValorTotal) < valorJaPago) {
      alert(`O valor total não pode ser menor que o valor já pago (R$ ${formatarMoeda(valorJaPago.toFixed(2))})`);
      return;
    }

    setSalvando(true);
    try {
      await onSalvarEdicao(lancamento._id, {
        valorTotal: Number(novoValorTotal),
        numeroParcelas: Number(novasParcelas),
        dataInicio,
        descricao
      });
      setModoEdicao(false);
    } catch (err) {
      alert("Erro ao renegociar lançamento: " + (err.response?.data?.erro || err.message));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content" style={{ maxWidth: "1024px", width: "100%" }}>
        <div className="modal-header">
          <h3>
            {modoEdicao
              ? `🔄 Renegociar / Editar Lançamento`
              : `DETALHES DO LANÇAMENTO - (${formatarNomeLower(lancamento.tipo.toUpperCase())})`}
          </h3>
        </div>

        <div className="modal-body" style={{ margin: "15px 0" }}>
          {!modoEdicao ? (
            /* --- MODO VISUALIZAÇÃO --- */
            <div>
              <p><strong>Descrição:</strong> {lancamento.descricao || "Sem descrição"}</p>
              <p><strong>Valor Total:</strong> R$ {formatarMoeda(Number(lancamento.valorTotal).toFixed(2))}</p>
              <p><strong>Valor Pago:</strong> R$ {formatarMoeda(valorJaPago.toFixed(2))}</p>
              
              <hr style={{ margin: "15px 0" }} />
              <h4>Parcelas do Contrato</h4>

              <table className="table" style={{ width: "100%", marginTop: "10px" }}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Valor</th>
                    <th>Vencimento</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {parcelas.map((p) => (
                    <tr key={p._id}>
                      <td>Parcela {p.numeroParcela}/{p.totalParcelas || lancamento.numeroParcelas}</td>
                      <td>R$ {formatarMoeda(Number(p.valor).toFixed(2))}</td>
                      <td>{new Date(p.dataVencimento).toLocaleDateString("pt-BR")}</td>
                      <td>
                        <span className={`badge ${p.status}`}>
                          {p.status === "pago" ? "Pago ✓" : p.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            /* --- MODO EDIÇÃO / RENEGOCIAÇÃO --- */
            <div className="form-renegociacao" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <div className="alert-info" style={{ background: "#f0fdf4", padding: "10px", borderRadius: "6px", border: "1px solid #bbf7d0" }}>
                ℹ️ <strong>Valor já pago: R$ {formatarMoeda(valorJaPago.toFixed(2))}</strong> ({parcelasPagas.length} parcela(s)).
                As parcelas pagas serão mantidas intactas.
              </div>

              <div>
                <label>Novo Valor Total (R$):</label>
                <input
                  type="number"
                  className="input-field"
                  value={novoValorTotal}
                  onChange={(e) => setNovoValorTotal(e.target.value)}
                />
              </div>

              {lancamento.tipo === "parcelado" && (
                <>
                  <div>
                    <label>Novo Total de Parcelas (Incluindo as já pagas):</label>
                    <input
                      type="number"
                      min={parcelasPagas.length + 1}
                      className="input-field"
                      value={novasParcelas}
                      onChange={(e) => setNovasParcelas(e.target.value)}
                    />
                  </div>

                  <div>
                    <label>Vencimento da 1ª Parcela Restante:</label>
                    <input
                      type="date"
                      className="input-field"
                      value={dataInicio}
                      onChange={(e) => setDataInicio(e.target.value)}
                    />
                  </div>
                </>
              )}

              <div>
                <label>Descrição / Observação:</label>
                <input
                  type="text"
                  className="input-field"
                  value={descricao}
                  onChange={(e) => setDescricao(e.target.value)}
                />
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer" style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          {!modoEdicao ? (
            <>
              <button className="btn-cancel" onClick={onClose}>Voltar</button>
              <button className="btn-primary" onClick={() => setModoEdicao(true)}>
                🔄 Renegociar / Editar
              </button>
            </>
          ) : (
            <>
              <button className="btn-cancel" onClick={() => setModoEdicao(false)} disabled={salvando}>
                Cancelar
              </button>
              <button className="btn-primary" onClick={handleSalvar} disabled={salvando}>
                {salvando ? "Salvando..." : "💾 Salvar Alterações"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}